// reducers/departmentReducer.js
export const departmentReducer = (
  state = { departments: [], pending: [], rejected: [] },
  action,
) => {
  switch (action.type) {
    case "ALL_DEPARTMENTS_REQUEST":
    case "PENDING_DEPARTMENTS_REQUEST":
    case "CREATE_DEPARTMENT_REQUEST":
    case "UPDATE_DEPARTMENT_REQUEST":
    case "DELETE_DEPARTMENT_REQUEST":
      return { ...state, loading: true };

    case "ALL_DEPARTMENTS_SUCCESS":
      return { ...state, loading: false, departments: action.payload || [] };

    case "PENDING_DEPARTMENTS_SUCCESS":
      return { ...state, loading: false, pending: action.payload || [] };

    case "REJECTED_DEPARTMENTS_SUCCESS":
      return { ...state, rejected: action.payload || [] };

    case "CREATE_DEPARTMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        departments: [...state.departments, action.payload],
      };

    // A new value typed on the Add Staff/Student form — goes to "pending".
    case "SUGGEST_DEPARTMENT_SUCCESS":
      return { ...state, success: true };

    case "APPROVE_DEPARTMENT_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        departments: [...state.departments, action.payload].sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
      };

    case "REJECT_DEPARTMENT_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        rejected: [...state.rejected, action.payload],
      };

    case "RESUBMIT_DEPARTMENT_SUCCESS":
      return {
        ...state,
        rejected: state.rejected.filter((d) => d.id !== action.payload.id),
        pending: [...state.pending, action.payload],
      };

    case "UPDATE_DEPARTMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        departments: state.departments.map((d) =>
          d.id === action.payload.id ? action.payload : d,
        ),
      };

    case "DELETE_DEPARTMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        departments: state.departments.filter((d) => d.id !== action.payload),
        pending: state.pending.filter((d) => d.id !== action.payload),
        rejected: state.rejected.filter((d) => d.id !== action.payload),
      };

    case "ALL_DEPARTMENTS_FAIL":
    case "PENDING_DEPARTMENTS_FAIL":
    case "REJECTED_DEPARTMENTS_FAIL":
    case "CREATE_DEPARTMENT_FAIL":
    case "SUGGEST_DEPARTMENT_FAIL":
    case "APPROVE_DEPARTMENT_FAIL":
    case "REJECT_DEPARTMENT_FAIL":
    case "RESUBMIT_DEPARTMENT_FAIL":
    case "UPDATE_DEPARTMENT_FAIL":
    case "DELETE_DEPARTMENT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
